import React, { useEffect, useState, Fragment, useRef } from "react";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { VarianceContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;

        return (
            <div>
                <h3><center><u>Field Factory Variance Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ fontSize: "12px" }} colSpan="5"></th>
                                <th style={{ fontSize: "12px", background: "lightgreen" }} colSpan="4">Field</th>
                                <th style={{ fontSize: "12px", background: "lightyellow" }} colSpan="4">Factory</th>
                                <th colSpan="2">Variance</th>
                            </tr>
                            <tr>
                                <th style={{ fontSize: "12px" }}>Estate</th>
                                <th style={{ fontSize: "12px" }}>Division</th>
                                <th style={{ fontSize: "12px" }}>Factory</th>
                                <th style={{ fontSize: "12px" }}>GTN No</th>
                                <th style={{ fontSize: "12px" }}>Field</th>
                                <th style={{ fontSize: "12px" }}>Bag Count</th>
                                <th style={{ fontSize: "12px" }}>Gross</th>
                                <th style={{ fontSize: "12px" }}>Deduction</th>
                                <th style={{ fontSize: "12px" }}>Net</th>
                                <th style={{ fontSize: "12px" }}>Bag Count</th>
                                <th style={{ fontSize: "12px" }}>Gross</th>
                                <th style={{ fontSize: "12px" }}>Deduction</th>
                                <th style={{ fontSize: "12px" }}>Net</th>
                                <th style={{ fontSize: "12px" }}>Net Variance</th>
                                <th style={{ fontSize: "12px" }}>Gross Variance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <VarianceContent
                                data={resultData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>

                </div>
            </div>
        );
    }
}